export const getEdgeThickness = (
  thicknessThresholds: number[],
  groupSize: number,
): number => {
  const foundThresholdIndex = thicknessThresholds.findIndex(
    (thickness) => groupSize < thickness,
  );
  return foundThresholdIndex > -1
    ? foundThresholdIndex + 1
    : thicknessThresholds.length + 1;
};
